'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function AnalyticsTracker() {
  const pathname = usePathname();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        // Generate session ID if not exists
        let sessionId = sessionStorage.getItem('analytics_session_id');
        if (!sessionId) {
          // Use a more deterministic approach to avoid hydration mismatch
          sessionId = `session_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
          sessionStorage.setItem('analytics_session_id', sessionId);
        }

        // Get referrer
        const referrer = document.referrer || '';

        // Track page view
        await fetch('/api/analytics', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page: pathname,
            userAgent: navigator.userAgent,
            ip: '', // Will be set by server
            referrer,
            sessionId
          }),
        });

        // Also send a GA4 page_view on client-side navigation if gtag is available
        const gaId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID;
        if (gaId && typeof (window as any).gtag === 'function') {
          // Update GA4 config for SPA navigation
          (window as any).gtag('config', gaId, {
            page_path: pathname,
            page_location: window.location.href,
            page_title: document.title,
          });

          // Send explicit GA4 page_view event (helps some verification tools)
          (window as any).gtag('event', 'page_view', {
            page_path: pathname,
            page_location: window.location.href,
            page_title: document.title,
          });
        }
      } catch (error) {
        console.error('Error tracking page view:', error);
      }
    };

    // Track page view after a short delay to ensure page is loaded
    const timer = setTimeout(trackPageView, 1000);
    return () => clearTimeout(timer);
  }, [pathname]);

  return null; // This component doesn't render anything
} 
